module.exports = __webpack_public_path__ + "static/img/recondo-2.a6671b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/recondo-2.jpg
// module id = DEKY
// module chunks = 1